<template>
  <div @focusin="$emit('focusIn', $event)" @focusout="$emit('focusOut', $event)">
    <!-- <bubble-menu
      class="bubble-menu uk-background-secondary uk-border-rounded uk-padding-remove uk-flex"
      :tippy-options="{ duration: 100 }"
      :editor="editor"
      v-if="editor && !disabled">
      <button
        v-for="btn in bubbleMenu" :key="btn.label"
        class="uk-button uk-button-secondary uk-button-small uk-padding-small uk-border-rounded"
        :class="{ 'is-active': editor.isActive('heading', btn.level ? { level: btn.level } : null) }"
        @click="editor.chain().focus()[`toggle` + btn.toggle[0].toUpperCase() + btn.toggle.substring(1)](btn.level ? { level: btn.level } : null).run()">
        <span v-html="btn.label"></span>
      </button>
    </bubble-menu>

    <floating-menu
      class="floating-menu uk-background-secondary uk-border-rounded uk-padding-remove uk-flex"
      :tippy-options="{ duration: 100 }"
      :editor="editor"
      v-if="editor && floatingMenu.length > 0 && !disabled">
      <button
        v-for="btn in floatingMenu" :key="btn.label"
        class="uk-button uk-button-secondary uk-button-small uk-padding-small uk-border-rounded"
        :class="{ 'is-active': editor.isActive('heading', btn.level ? { level: btn.level } : null) }"
        @click="editor.chain().focus()[`toggle` + btn.toggle[0].toUpperCase() + btn.toggle.substring(1)](btn.level ? { level: btn.level } : null).run()">
        {{ btn.label }}
      </button>
    </floating-menu> -->

    <editor-content class="annotations-content" :editor="editor" />

    <div class="text-meta-data uk-flex">
      <slot name="metadata"></slot>
      <div class="invisible-divider"></div>
      <div v-if="editor && maxCharacters && !disabled && focused" class="character-count">
        Characters left:
        <span :style="getCharacterCounterStyle">{{
          maxCharacters - editor.extensionStorage.characterCount.characters()
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Editor,
  EditorContent,
  // BubbleMenu,
  // FloatingMenu,
} from '@tiptap/vue-3';
import CharacterCount from '@tiptap/extension-character-count';
import StarterKit from '@tiptap/starter-kit';
import Link from '@tiptap/extension-link';
import Focus from '@tiptap/extension-focus';
import Placeholder from '@tiptap/extension-placeholder';
import KeyDownHandlerFactory from '@/plugins/tiptap/TipTapKeyDownHandler';

export default {
  name: 'TipTap',

  components: {
    EditorContent,
    // BubbleMenu,
    // FloatingMenu,
  },

  props: {
    modelValue: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxCharacters: {
      type: Number,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
  },

  model: {
    prop: 'modelValue',
    event: 'updateModelValue',
  },

  emits: [
    'keydownEnter',
    'keydownArrowUp',
    'keydownArrowDown',
    'keydown',
    'editorCreated',
    'updateModelValue',
    'focusIn',
    'focusOut',
  ],

  data() {
    return {
      editor: null,

      bubbleMenu: [
        { label: '<b>B</b>', toggle: 'bold' },
        { label: '<i>I</i>', toggle: 'italic' },
        { label: '<s>S</s>', toggle: 'strike' },
        { label: 'H1', toggle: 'heading', level: 1 },
        { label: 'H2', toggle: 'heading', level: 2 },
        { label: 'List', toggle: 'bulletList' },
      ],

      floatingMenu: [],
      KeyDownHandler: KeyDownHandlerFactory((ev, view) => {
        this.$emit('keydown', { ev, view, tiptap: this });
      }),
      focused: false,
    };
  },

  computed: {
    characterCountWithinLimit() {
      return (
        this.editor &&
        this.maxCharacters &&
        this.editor.extensionStorage.characterCount.characters() < this.maxCharacters
      );
    },
    getCharacterCounterStyle() {
      if (!this.characterCountWithinLimit) return { color: 'red' };
      return {};
    },
  },

  mounted() {
    let extensions = [
      StarterKit,
      Link,
      CharacterCount.configure({
        limit: this.maxCharacters,
      }),
      Focus.configure({
        className: 'has-focus',
        mode: 'all',
      }),
      this.KeyDownHandler,
    ];

    if (this.placeholder) {
      extensions.push(
        Placeholder.configure({
          placeholder: this.placeholder,
        })
      );
    }

    this.editor = new Editor({
      extensions,
      // handleDOMEvents: {
      //   keydown: (view, event) => {
      content: this.modelValue,
      editable: !this.disabled,
      onCreate: () => {
        this.$emit('editorCreated');
      },
      onUpdate: () => {
        // HTML
        // TODO: only update if input is valid?
        // if (this.characterCountWithinLimit)
        this.$emit('updateModelValue', this.editor.getHTML());

        // JSON
        // this.$emit('updateModelValue', this.editor.getJSON())
      },
      onFocus: () => {
        this.focused = true;
      },
      onBlur: () => {
        this.focused = false;
      },
    });
  },

  beforeUnmount() {
    this.editor.destroy();
  },

  watch: {
    modelValue(value) {
      // HTML
      const isSame = this.editor.getHTML() === value;

      // JSON
      // const isSame = this.editor.getJSON().toString() === value.toString()

      if (isSame) {
        return;
      }

      this.editor.commands.setContent(value, false);
    },

    disabled(value) {
      this.editor.editable = !value;
      this.editor.options.editable = !value;
      this.editor.view.update(this.editor.view.props);
    },
  },

  methods: {
    setFocus() {
      this.editor.chain().focus('end');
    },
  },
};
</script>
